import React, { Component } from 'react';
import { Spinner } from 'react-redux-spinner';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../redux/actions/index';
import { Router, Route } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';
import TravcoHeader from 'travco-header';
import { TravcoFooter } from 'travco-footer';
import InventoryPage from './setup/setup-container';
import CallbackPage from './callback-page';
import { userManager } from '../utils/user-manager';
import Search from './search-page';
import { TravcoCommonLinks } from 'travco-common-links';
import toastr from 'toastr';
import _isEqual from 'lodash/isEqual';

const history = createBrowserHistory();

class App extends Component {
    constructor(props) {
        super(props);
        this.signOut = this.signOut.bind(this);
        this.save = this.save.bind(this);

        this.state = {
            viewName: '',
            isSaving: false,
            initialData: []
        };

        if (window.location.pathname !== '/callback') {
            if (!props.oidc || !props.oidc.user || props.oidc.user.expired) {
                if (userManager.settings.authority) {
                    userManager.signinRedirect({
                        state: { returnTo: window.location.pathname + window.location.search }
                    });
                }
            }
        }
    }

    componentDidMount() {
        const { inventoryData } = this.props.model.inventory;
        this.readCurrentView(window.location);

        history.listen((location) => {
            this.readCurrentView(location);
        });

        this.setState({ initialData: inventoryData ? inventoryData.allocationByDay : [] });
    }

    componentDidUpdate(prevProps, prevState) {
        const { inventoryData } = this.props.model.inventory;
        if (prevState.isSaving !== this.state.isSaving && this.state.isSaving) {
            if (_isEqual(this.state.initialData, inventoryData.allocationByDay)) {
                this.setState({ isSaving: false });
                toastr.warning('Current data is already saved.');
            } else {
                this.props.actions
                    .saveInventory(this.props.model)
                    .then(() => this.setState({ isSaving: false, initialData: inventoryData.allocationByDay }))
                    .catch(() => this.setState({ isSaving: false }));
            }
        }
    }

    signOut() {
        userManager.signoutRedirect();
    }

    save() {
        this.setState({ isSaving: true });
    }

    cancel() {
        history.push('/');
    }

    readCurrentView(location) {
        const uri = location.pathname.split('/');
        if (location.pathname === '/' || uri[1] === 'search') this.setState({ viewName: 'Search' });
        else if (uri[1] === 'inventory-page' && uri.length < 3) this.setState({ viewName: 'Create' });
        else this.setState({ viewName: 'Edit' });
    }

    render() {
        const { settings, selectedHotel, headerInfo, userType } = this.props;
        const { viewName, isSaving } = this.state;
        let user = null;

        if (typeof this.props.oidc !== 'undefined' && this.props.oidc.user !== null) {
            user = this.props.oidc.user.profile;
        }

        return (
            <Router history={history}>
                <div className="app-wrapper">
                    <div className="app-header">
                        <Spinner />
                        <TravcoHeader
                            signOut={this.signOut}
                            service="inventory"
                            user={user}
                            domain={settings.serviceDomain}
                            settings={settings}
                            viewName={viewName}
                            otherView={null}
                            data={headerInfo}
                            mainAction={this.save}
                            mainActionIsVisible={viewName === 'Create' || viewName === 'Edit'}
                            mainActionIsActive={isSaving}
                            secondaryAction={this.cancel}
                            secondaryActionIsVisible={viewName === 'Create' || viewName === 'Edit'}
                        />
                        <TravcoCommonLinks
                            serviceDomain={settings.serviceDomain}
                            hotelId={selectedHotel ? selectedHotel.id : null}
                            settings={settings}
                            inventoryDisable
                            userType={userType}
                        />
                    </div>

                    <div className="app-body">
                        <Route exact path="/" component={Search} />
                        <Route exact path="/search/:id?/:rcId?" component={Search} />
                        <Route exact path="/inventory-page" component={InventoryPage} />
                        <Route exact path="/inventory-page/:id" component={InventoryPage} />
                        <Route path="/callback" component={CallbackPage} />
                    </div>
                    <div className="app-footer">
                        <TravcoFooter />
                    </div>
                </div>
            </Router>
        );
    }
}

function mapStateToProps(state) {
    if (state.oidc && state.oidc.user && state.oidc.user.profile) {
        if (
            state.oidc.user.profile.travco_user_type !== 'Travco' &&
            state.oidc.user.profile.travco_user_type !== 'Hotelier'
        ) {
            window.location = `https://ss100${state.settings.serviceDomain}.travco.co.uk`;
        }
    }

    return {
        oidc: state.oidc,
        userType: state.oidc.user ? state.oidc.user.profile.travco_user_type : null,
        settings: state.settings,
        model: state.model,
        selectedHotel: state.model.inventory.hotel,
        selectedRoomCategory: state.globalData.roomCategory || null,
        headerInfo: state.globalData.headerInfo || []
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
